import React from 'react';
import CalendarRangeChange from '../../Calendar/CalendarView/CalendarRangeChange';
import CalendarViewSwitch from '../../Calendar/CalendarView/CalendarViewSelection';
import {CalendarView} from '../../Calendar/CalendarView/constant';

interface CalendarFilterProps {
  currentDate: Date | null;
  setCurrentDate: (date: Date | null) => void;
  viewMode: 'day' | 'week' | 'month';
  setViewMode: (mode: 'day' | 'week' | 'month') => void;
  getRangeLabel: () => string;
  changeDateRange: (direction: 'next' | 'prev') => void;
}

const modeToEnum = (mode: 'day' | 'week' | 'month'): CalendarView => {
  switch (mode) {
    case 'day':
      return CalendarView.Day;
    case 'week':
      return CalendarView.Week;
    case 'month':
      return CalendarView.Month;
    default:
      return CalendarView.Week;
  }
};
const enumToMode = (view: CalendarView): 'day' | 'week' | 'month' => {
  switch (view) {
    case CalendarView.Day:
      return 'day';
    case CalendarView.Week:
      return 'week';
    case CalendarView.Month:
      return 'month';
    default:
      return 'week';
  }
};

const CalendarFilter: React.FC<CalendarFilterProps> = ({
  currentDate,
  setCurrentDate,
  viewMode,
  setViewMode,
  getRangeLabel,
  changeDateRange,
}) => {
  const handleViewChange = (mode: 'day' | 'week' | 'month') => {
    // set currentDate to null only if the view mode is the same as the current one and currentDate is not already null
    if (viewMode === mode && currentDate !== null) {
      setCurrentDate(null);
    } else {
      setViewMode(mode);
      setCurrentDate(new Date());
    }
  };

  return (
    <div className="flex gap-2 items-center">
      <CalendarRangeChange
        rangeText={currentDate ? getRangeLabel() : 'All Dates'}
        onPrev={currentDate ? () => changeDateRange('prev') : undefined}
        onNext={currentDate ? () => changeDateRange('next') : undefined}
        disabled={!currentDate}
      />
      <CalendarViewSwitch
        view={modeToEnum(viewMode)}
        changeView={v => handleViewChange(enumToMode(v))}
        currentDate={currentDate}
      />
    </div>
  );
};

export default CalendarFilter;
